import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Box';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "box"
    }}>{`Box`}</h1>
    <p>{`Responsive box-model layout component`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Box
  p={5}
  fontSize={4}
  width={[ 1, 1, 1/2 ]}
  color='white'
  bg='primary'>
  Box
</Box>
`}</code></pre>
    <p>{`The Box and Flex components are also available in the standalone `}<a parentName="p" {...{
        "href": "/reflexbox"
      }}>{`Reflexbox`}</a>{` package.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      